<template>
    <section>
        <div class="play-box pr">
            <video
              ref="video"
              :src="video.src"
              :poster="video.thumb"
              class="video"
              controls="controls"
              controlsList="nodownload"
              webkit-playsinline="true"
              playsinline="true"
              x-webkit-airplay="true"
              x5-video-player-type="h5"
              x5-video-player-fullscreen="true"
              x5-video-orientation="portraint"
              x5-video-ignore-metadata="true"
            >
            </video>

            <!--<video ref="video" :src="video.src" :poster="video.thumb" @play="pause" @timeupdate="pause" class="video" controls="controls" webkit-playsinline="true" playsinline="true" x-webkit-airplay="true" x5-video-player-type="h5" x5-video-player-fullscreen="true" x5-video-ignore-metadata="true"></video>
            <div v-show="maskShow" class="play-over pa" :style="`background-image: url(${video.thumb})`">
                <div class="df pa play-over-main">
                    <div class="play-over-top">
                        <div class="over-title">1分钟试看结束啦，观看全片：</div>
                        <div class="df">
                            <img class="play-over-thumb" :src="video.thumb" alt="">
                            <div class="df fdc jcsa">
                                <div class="play-over-title">{{video.title}}</div>
                                <div>
                                    <a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.vhiphop.app" class="open-btn">App 内打开</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="df jcfe">
                        <div @touchend.prevent="reload" class="df ac"><i class="icon-reload"></i> 重新播放</div>
                    </div>
                </div>
            </div>-->
        </div>

        <div class="main">
            <div v-for="v in video.dancers" class="user-list">
                <router-link :to="`/dancers/${v.id}`">
                    <img :src="v.thumb" class="dancer-avatar" alt="">
                </router-link>
                <div class="user-right">
                    <router-link :to="`/dancers/${v.id}`" class="user-info">
                        <div class="user-name">{{v.name}}</div>
                        <div>{{v.tip}}</div>
                    </router-link>
                    <a class="follow" href="http://a.app.qq.com/o/simple.jsp?pkgname=com.vhiphop.app">关注</a>
                </div>
            </div>
            <div v-if="video.studio" class="user-list">
                <router-link :to="`/studios/${video.studio.id}`">
                    <img :src="video.studio.thumb" class="dancer-avatar" alt="">
                </router-link>
                <div class="user-right">
                    <router-link :to="`/studios/${video.studio.id}`" class="user-info">
                        <div class="user-name">{{video.studio.name}}</div>
                        <div>{{video.studio.tip}}</div>
                    </router-link>
                    <a class="follow" href="http://a.app.qq.com/o/simple.jsp?pkgname=com.vhiphop.app">关注</a>
                </div>
            </div>
            <div class="info-box pr">
                <i @touchend.prevent="digestShow = !digestShow" :class="`icon-arrow-down df pa${digestShow ? ' arrow-rotate' : ''}`"></i>
                <div v-show="!digestShow">
                    <div class="title single-title">{{video.title}}</div>
                    <div class="view">{{$view(video.views)}}次观看 | {{$time(video.addtime)}}</div>
                </div>
                <div v-show="digestShow">
                    <div class="title complete-title">{{video.title}}</div>
                    <div class="view">{{$view(video.views)}}次观看 | {{$time(video.addtime)}}</div>

                    <div v-show="video.digest" class="digest">{{video.digest}}</div>

                    <div v-show="video.sorts" class="sort-box">
                        <router-link :to="`/videos?sort=${v.id}`" v-for="v in video.sorts" :key="v.id" class="sort">{{v.name}}</router-link>
                    </div>
                </div>

                <div class="tool-box">
                    <div class="tool-l">
                        <a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.vhiphop.app"><i class="icon-collect"></i>收藏</a>
                        <a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.vhiphop.app"><i class="icon-download"></i>缓存</a>
                        <div @click="share"><i class="icon-share"></i>分享</div>
                    </div>
                    <div @touchend.prevent="toComment">
                        <i class="icon-comments"></i>{{video.comments}} 评论
                    </div>
                </div>
            </div>
        </div>
        <div class="video-box df jcsb">
            <a v-for="v in videos" :key="v.id" :to="`/videos/${v.id}`" href="http://a.app.qq.com/o/simple.jsp?pkgname=com.vhiphop.app" class="video-link">
                <div class="video-thumb" :style="`background-image: url(${v.thumb})`">
                    <div class="video-meta">
                        <div class="video-meta-play">
                            <i class="icon-play"></i>{{$view(v.views)}}
                        </div>
                        <i class="icon-comment"></i>{{v.comments}}
                    </div>
                </div>
                <div class="video-title">{{v.title}}</div>
            </a>
        </div>
        <div ref="comment" class="comment">
            <div class="comment-title">评论（{{video.comments}}）</div>
            <div class="comment-list-box">
                <div v-for="v in comments" :key="v.id" class="comment-list">
                    <img :src="v.thumb" class="user-avatar" alt="">
                    <div class="comment-info">
                        <div class="user-name">{{v.nico}}</div>
                        <div class="comment-time">{{$time(v.addtime)}}</div>
                        <div class="comment-content">{{v.content}}</div>
                    </div>
                </div>
                <div v-if="!comments.length" class="empty">暂时没有评论(～￣▽￣)～</div>
                <a v-if="comments.length" class="empty download" href="http://a.app.qq.com/o/simple.jsp?pkgname=com.vhiphop.app">查看全部评论，请下载 Vhiphop 客户端 >></a>
            </div>
        </div>
    </section>

</template>

<script>
    export default {
        data: () => ({
            digestShow: false,
            maskShow: false,
            video: {
                title: '',
                src: '',
                addtime: '',
                views: 0,
                comments: 0,
            },
            videos: [],
            comments: [],
        }),
        computed: {
            id() {
                return this.$route.params.id;
            },
        },
        methods: {
            exitFull() {
                if (!document.fullscreenElement || document.fullscreenElement.nodeName !== 'VIDEO') return;
                const exitMethod = document.exitFullscreen ||
                    document.webkitExitFullscreen || // Webkit (works in Safari and Chrome)
                    document.mozCancelFullScreen || // Firefox (works in nightly)
                    document.msExitFullscreen; // W3C
                if (exitMethod) {
                    exitMethod.call(document);
                } else if (typeof window.ActiveXObject !== "undefined") { //for Internet Explorer
                    const wscript = new ActiveXObject("WScript.Shell");
                    if (wscript !== null) {
                        wscript.SendKeys("{F11}");
                    }
                }
            },
            fullScreen() {
                this.$refs.video.requestFullscreen();
            },
            pause() {
                if (this.$refs.video.currentTime > 60) {
                    this.$refs.video.pause();
                    this.maskShow = true;
                    this.exitFull();
                }
            },
            reload() {
                this.$refs.video.currentTime = 0;
                this.$refs.video.play();
                this.maskShow = false;
            },
            share() {
                window.alert('想分享给更多好友？复制上面的链接发给他们');
            },
            toComment() {
                this.$refs.comment.scrollIntoView();
            },
        },
        beforeMount() {
            const {api} = this;
            Promise.all([
                api.get(`videos/${this.id}`).then(e => {
                    this.video = e;
                    this.$share(e.title, e.thumb);
                }),
                api.get(`videos/${this.id}/reco`).then(e => this.videos = e),
                api.get(`videos/${this.id}/comments`).then(e => this.comments = e)
            ]).catch(this.err);
        },
    }
</script>

<style scoped>
    @import '../../../static/css/video/detail.css';
    @import '../../../static/css/home/video-list.css';
    @import '../../../static/css/dancer/activity-detail.css';

    .comment {
        margin-top: 1.06vw;
        background-color: inherit;
    }
</style>



// WEBPACK FOOTER //
// src/components/video/Detail.vue